import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withContent } from '@bubbletea/core';
import uniqueId from 'lodash/uniqueId';
import { IContent } from '../../../types';

import Title from '../../UI/Title';
import PromoCard from './PromoCard';

import { ContentWrapper, PromoCardsSection, TitleContainer } from './styles';
import sendEvent from '../../../utils/sendEvent';
import { IStoreState } from '../../../types/store';

interface IPlansProps {
  context: IContent;
}

const Plans = ({ context }: IPlansProps) => {
  const [impressionEventRegistered, setImpressionEventRegistered] = useState(false);
  const contentSelector = useSelector((state: IStoreState) => ({
    analyticsLoaded: state.app.analyticsLoaded,
  }));
  const { analyticsLoaded } = contentSelector;

  useEffect(() => {
    const impressionEventDetails = {
      location: 'promotional offers',
      category: 'scroll',
      locationPosition: 5,
      action: 'visible',
    };
    if (analyticsLoaded && impressionEventRegistered) {
      setImpressionEventRegistered(false);
      sendEvent(impressionEventDetails, 'impressionevent');
    }
  }, [impressionEventRegistered, analyticsLoaded]);

  const { googlesheet } = context;
  const { promoOffers } = googlesheet;

  return (
    <ContentWrapper
      id={'promo_offers'}
      whileInView={'sendevent'}
      onAnimationStart={() => setImpressionEventRegistered(true)}
      viewport={{ once: true }}
    >
      <div className="section-wrapper">
        <TitleContainer>
          <Title as="h3" textAlign="center" uppercase>
            {promoOffers.title}
          </Title>
        </TitleContainer>
        <PromoCardsSection>
          {promoOffers.offersItems.map(
            (item, index) =>
              item.enabled && (
                <PromoCard key={`promo_${uniqueId()}`} hasAltTitleColor={index === 0} offer={item} index={index} />
              )
          )}
        </PromoCardsSection>
        <p>{`${promoOffers.caption.default}${
          promoOffers.caption.enableUbisoftPlus ? promoOffers.caption.ubisoftPlus : ''
        }`}</p>
      </div>
    </ContentWrapper>
  );
};

export default withContent(Plans);
